import { Route, Routes } from "react-router-dom";
import NotFound from "../../components/_page/notFound/NotFound";
import CreateTokenKit from "./CreateTokenKit";
import ManageTokenKit from "./ManageTokenKit";
import MyKits from "./MyKits";
import TokenizeMain from "./TokenizeMain";

const TokenizationRouter = () => {
  return (
    <Routes>
      <Route path={"*"} element={<TokenizeRouter />} />
      <Route path={"my-kits/*"} element={<MyKitsRouter />} />
    </Routes>
  );
};
export default TokenizationRouter;

const TokenizeRouter = () => {
  return (
    <Routes>
      <Route index element={<TokenizeMain />} />
      <Route path={"create/*"}>
        <Route path={"token"} element={<CreateTokenKit />} />
        {/* <Route path={"nft"} element={<CreateNFTKit />} /> */}
        {/* <Route path={'membership'} element={<CreateMembershipKit />} /> */}
        <Route path={"*"} element={<NotFound />} />
      </Route>
      <Route path={"*"} element={<NotFound />} />
    </Routes>
  );
};

const MyKitsRouter = () => {
  return (
    <Routes>
      <Route index element={<MyKits />} />
      <Route path={"token/:id"} element={<ManageTokenKit />} />
      {/* <Route path={"nft/:id"} element={<ManageNFTKit />} /> */}
      {/* <Route path={"membership/:id"} element={<ManageNFTKit />} /> */}
      <Route path={"*"} element={<NotFound />} />
    </Routes>
  );
};
